import React, { useEffect, useState } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledChat } from "../../styled-components/StyledChat.style";
import api from '../../services/api';
import Swal from "sweetalert2";
import { Multiselect } from 'multiselect-react-dropdown';
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { MentionsInput, Mention } from 'react-mentions'
import defaultStyle from './defaultStyle'

export const ModalEsclarecimento = ({
    loadPage,
    isOpen,
    setIsOpen,
    timesheet
}) => {
    const [isLoading, setisLoading] = useState(false);
    var [usuarios, setUsuarios] = useState([]);
    var [selectedUsuarios, setSelectedUsuarios] = useState([]);
    var [selectedUsuariosId, setSelectedUsuariosId] = useState([]);
    var [loadingChat, setLoadingChat] = useState(false);
    const [descricaoAtividade, setDescricaoAtividade] = useState("");
    const [descricaoAtividadeTexto, setDescricaoAtividadeTexto] = useState("");
    const [mensagens, setMensagens] = useState([]);
    const [esclarecimento, setEsclarecimento] = useState([]);

    const onChangeMentions = (event, newValue, newPlainTextValue, mentions) => {
        setDescricaoAtividade(newPlainTextValue)
        setDescricaoAtividadeTexto(newPlainTextValue)
    } 

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onAfterOpen = () => { };

    const closeModal = () => {
        setIsOpen(false);
    }

    const formActivities = async (concluir) => {
        if (descricaoAtividade == "" && !concluir) {
            Swal.fire({
                title: "Atenção",
                text: "É necessário informar uma mensagem!",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        }

        if(selectedUsuariosId.length == 0) {
            Swal.fire({
                title: "Atenção",
                text: "Selecione ao menos 1 usuário!",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        }

        setLoadingChat(true)
        var payload = {
            idTimesheet: timesheet?.timesheet?.idTimesheet,
            mensagem: descricaoAtividadeTexto,
            concluir: concluir,
            idUsuarios: selectedUsuariosId
        }
        try {
            await api.post(`timesheet/esclarecimento`, payload);
            if(concluir) {
                await loadPage()
                setIsOpen(false)
            }
            await loadEsclarecimento(false)
            setDescricaoAtividade("")
            setDescricaoAtividadeTexto("")
            setLoadingChat(false)
        } catch (err) {
            setLoadingChat(false)
        }
    };

    const loadEsclarecimento = async (isLoading) => {
        setisLoading(isLoading)
        try {
            const response = await api.get(`Aprovacoes/${timesheet?.timesheet?.idTimesheet}/usuariosesclarecimento`, config);
            var data = response.data.data
            setEsclarecimento(data.esclarecimento)
            const peritosFormatados = []
            data.usuarios.map(perito => {
                var item = {
                    "value": perito.id,
                    "id": perito.id,
                    "label": perito.nomeTSImport,
                    "display": perito.nomeTSImport
                };
                peritosFormatados.push(item);
            });
            if(data.esclarecimento) {
                if(data.esclarecimento.idUsuarios?.length > 0) {
                    var usuariosMencionados = peritosFormatados.filter(per => data.esclarecimento.idUsuarios.indexOf(per.id) > -1)
                    setSelectedUsuarios(usuariosMencionados);
                    setSelectedUsuariosId(usuariosMencionados.map(m=> m.id))
                }
                else {
                    setSelectedUsuarios([]);
                    setSelectedUsuariosId([])
                }
                if(data.esclarecimentoMensagens) setMensagens(data.esclarecimentoMensagens)
                else setMensagens([])
            }
            else {
                let dadosUsuario = JSON.parse(localStorage.getItem("PROFILE_DATA_SISCOPE"));
                var usuariosMencionados = peritosFormatados.filter(per => data.esclarecimento.idUsuarios.indexOf(dadosUsuario.idUsuario) > -1)
                setMensagens([])
                setSelectedUsuarios(usuariosMencionados);
                setSelectedUsuariosId(usuariosMencionados.map(m=> m.id))
            }
            setUsuarios(peritosFormatados)
            setisLoading(false)
        } catch (err) {
            setisLoading(false)
        }
    }

    useEffect(() => {
        if(isOpen) {
            setUsuarios([])
            loadEsclarecimento(true)
        }
    }, [isOpen])

    const onGetUsuario = (currentValue, value) => {
        let UsuariosList = [];
        currentValue.map(a => { UsuariosList.push(a.id) });
        setSelectedUsuariosId(UsuariosList);
        setSelectedUsuarios(currentValue)
    };

    const onRemoveUsuario = (currentValue, value) => {
        onGetUsuario(currentValue)
    }

    const onAdd =  (id, display, startPos, endPos) => {
        if(selectedUsuarios.find(u=> u.id == id))
            return

        var usu = [...selectedUsuarios]
        usu.push(usuarios.find(u=> u.id == id))
        onGetUsuario(usu)
    }

    const onChange =   (event, newValue, newPlainTextValue, mentions) => {
        console.log(newPlainTextValue)
    } 

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={closeModal}>X</p>
            </StyledForm>
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <p className="modal-title">Esclarecimento</p>
                    </Flex.Item>
                </Flex>
                    {isLoading ? (
                        <div className="text-center">
                            <div className="text-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            </div>
                        </div>
                    ) : (
                        <>
                        <Flex>
                            <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-0">
                                <Multiselect
                                    className="searchWrapperCustom"
                                    placeholder={'Profissionais'}
                                    showCheckbox="true"
                                    options={usuarios}
                                    selectedValues={selectedUsuarios}
                                    onSelect={onGetUsuario}
                                    onRemove={onRemoveUsuario}
                                    displayValue="label"
                                    showArrow={true}
                                />
                            </div>
                        </Flex>

                        <StyledTablePage>
                            <StyledChat className="chat-history">
                                <Flex.Item style={{ marginTop: '7px', borderBottom: '2px solid white' }}>
                                    <ul className="list-unstyled">
                                        {
                                            mensagens.map((mensagem, index) => {
                                                var leftRight = "right"
                                                // if(index != 0 && mensagem.nomeUsuario != mensagens[index-1].nomeUsuario) {
                                                //     leftRight = "left"
                                                // }

                                                return (
                                                    <li className="clearfix">
                                                        <div className={`message-data text-${leftRight}`}>
                                                            <span className="message-data-time" >{mensagem.dataCriacao}</span> &nbsp;
                                                            <span className="message-data-name" ><b>{mensagem.nomeUsuario}</b></span>
                                                        </div>
                                                        <div className={`message other-message text-${leftRight}`} style={{ wordBreak: "break-all" }}>
                                                            {mensagem.mensagem}
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </Flex.Item>
                                <Flex>
                                    <Flex.Item style={{ width: '100%' }} className="chat-message">
                                        <MentionsInput 
                                            value={descricaoAtividade} 
                                            onChange={onChangeMentions}
                                            style={defaultStyle}
                                            allowSpaceInQuery={true}
                                            placeholder={"Escreva sua mensagem aqui(Você pode mencionar os profissionais envolvidos digitando @)"}
                                        >
                                            <Mention 
                                                trigger="@" 
                                                data={usuarios}
                                                appendSpaceOnAdd={true}
                                                onAdd={onAdd}
                                            />
                                        </MentionsInput>
                                    </Flex.Item>
                                </Flex>
                                <Flex style={{ textAlign: "right" }}>
                                    <Flex.Item style={{ width: '100%' }}>
                                        {
                                            loadingChat ?
                                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                : <input className='default-button-red button-chat' value='Enviar' type="button" onClick={() => formActivities(false)} />
                                        }
                                    </Flex.Item>
                                </Flex>
                            </StyledChat>
                        </StyledTablePage>
                        {
                            esclarecimento && esclarecimento.status == 1 && (
                                <Flex>
                                    <Flex.Item className="modal-width">
                                        <div className="position-relative form-group modal-text-center mt-3 text-center">
                                            <input 
                                                className='default-button-red' 
                                                value={esclarecimento && esclarecimento.status != 5 ? 'Marcar como esclarecido' : 'Solicitar esclarecimento'} 
                                                type="button" onClick={() => formActivities(esclarecimento && esclarecimento.status != 5 || false)} />
                                        </div>
                                    </Flex.Item>
                                </Flex>
                            )
                        }

                        </>
                    )}
            </StyledForm>
        </Modal>);
};
